import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_oss_company_selector = _resolveComponent("oss-company-selector")!
  const _component_oss_company_activities_selector = _resolveComponent("oss-company-activities-selector")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_AccountingClientMonitoringProductionRow = _resolveComponent("AccountingClientMonitoringProductionRow")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AccountingClientMonitoringTaxesRow = _resolveComponent("AccountingClientMonitoringTaxesRow")!
  const _component_AccountingClientMonitoringClosureRow = _resolveComponent("AccountingClientMonitoringClosureRow")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "3" }, {
            default: _withCtx(() => [
              _createVNode(_component_DateRangePicker, {
                begin: _ctx.startDate,
                end: _ctx.endDate,
                onChangeDateRange: _ctx.onDateRangeChanged,
                hideDetails: true,
                type: 'month',
                formatDate: 'month',
                dense: "",
                prefixDataCy: "AccountingClientMonitoring-month"
              }, null, 8, ["begin", "end", "onChangeDateRange"])
            ]),
            _: 1
          }),
          (_ctx.mode === 'InternalManagement')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    readonly: "",
                    outlined: "",
                    onClick: _ctx.openUserDialog,
                    "hide-details": "",
                    "data-cy": "AccountingClientMonitoring-collaborateur",
                    "model-value": _ctx.selectedUser.firstname + ' ' + _ctx.selectedUser.lastname,
                    density: "compact"
                  }, null, 8, ["onClick", "model-value"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "2",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    label: "Recherche",
                    outlined: "",
                    "hide-details": "",
                    "data-cy": "AccountingClientMonitoring-search",
                    density: "compact",
                    clearable: "",
                    "append-inner-icon": "$search"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })),
          _createVNode(_component_v_col, {
            cols: "3",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_company_selector, {
                modelValue: _ctx.companiesSelected,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companiesSelected) = $event)),
                multiple: true,
                items: _ctx.allAvailableCompanies,
                label: 'Société',
                hideDetails: true,
                chipMaxLength: 19,
                vSelectProps: { bgColor: 'white' },
                "data-cy": "AccountingClientMonitoring-societe"
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oss_company_activities_selector, {
                modelValue: _ctx.codeNafSelected,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.codeNafSelected) = $event)),
                inActivities: _ctx.activities,
                multiple: true,
                hideDetails: true
              }, null, 8, ["modelValue", "inActivities"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "2",
            class: "pl-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.legalFormsSelected,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.legalFormsSelected) = $event)),
                items: _ctx.legalForms,
                chips: "",
                outlined: "",
                "hide-details": "",
                label: "Formes légales",
                multiple: "",
                "data-cy": "AccountingClientMonitoring-formesLegales",
                density: "compact"
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "d-flex align-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "4" }, {
            default: _withCtx(() => [
              (_ctx.isUserHasAccess)
                ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                    key: 0,
                    modelValue: _ctx.selectedView,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedView) = $event)),
                    class: "pt-1",
                    group: "",
                    mandatory: "",
                    rounded: "xl",
                    density: "compact",
                    variant: "text",
                    color: "primary",
                    style: {"overflow":"hidden"}
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isUserAllowedToProduction)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            value: "production",
                            class: "mx-0",
                            "data-cy": "AccountingClientMonitoring-production",
                            style: {"border-top-left-radius":"16px","border-bottom-left-radius":"16px"}
                          }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                              _createTextVNode(" Production ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isUserAllowedToDeclaration)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            class: "mx-0",
                            "data-cy": "AccountingClientMonitoring-taxes",
                            value: _ctx.taxesTypeSelected,
                            style: {"border-radius":"0"}
                          }, {
                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                              _createTextVNode(" Déclarations ")
                            ])),
                            _: 1
                          }, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.isUserAllowedToInvoices)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            value: "finalization",
                            class: "mx-0",
                            "data-cy": "AccountingClientMonitoring-finalization",
                            style: {"border-top-right-radius":"16px","border-bottom-right-radius":"16px"}
                          }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createTextVNode(" Clôture ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.selectedView && _ctx.selectedView?.includes('taxes'))
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    outlined: "",
                    modelValue: _ctx.taxesTypeSelected,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.taxesTypeSelected) = $event)),
                    items: _ctx.taxesTypes,
                    "item-value": "value",
                    required: "",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.key
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              (_ctx.selectedView === 'production')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "d-flex justify-center align-start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_checkbox, {
                            dense: "",
                            modelValue: _ctx.showFECInfo,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showFECInfo) = $event)),
                            label: "FEC",
                            "hide-details": "auto",
                            "data-cy": "AccountingClientMonitoring-FEC"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                        return (_openBlock(), _createBlock(_component_v_col, {
                          class: "d-flex justify-center align-start",
                          key: option
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              dense: "",
                              modelValue: _ctx.optionsSelected,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.optionsSelected) = $event)),
                              label: _ctx.translateOption(option),
                              "hide-details": "auto",
                              "data-cy": 'AccountingClientMonitoring-' + _ctx.translateOption(option),
                              value: option
                            }, null, 8, ["modelValue", "label", "data-cy", "value"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_ctx.selectedView === 'taxesDeposits')
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 1,
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxesDeposits, (tax) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            class: "d-flex justify-center align-end",
                            key: `${tax}-deposit`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_checkbox, {
                                dense: "",
                                modelValue: _ctx.taxesDepositsSelected,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.taxesDepositsSelected) = $event)),
                                label: tax,
                                "hide-details": "auto",
                                "data-cy": 'AccountingClientMonitoring-taxesSelected-' + tax,
                                value: tax
                              }, null, 8, ["modelValue", "label", "data-cy", "value"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_ctx.selectedView === 'taxesBalances')
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 2,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxesBalances, (tax) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              class: "d-flex justify-center align-end",
                              key: `${tax}-balance`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  dense: "",
                                  modelValue: _ctx.taxesBalancesSelected,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.taxesBalancesSelected) = $event)),
                                  label: tax,
                                  "hide-details": "auto",
                                  value: tax
                                }, null, 8, ["modelValue", "label", "value"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.mappedSelectedView,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.mappedSelectedView) = $event)),
                rounded: "xl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, {
                    class: "mt-1",
                    value: "production"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_data_table_server, {
                                headers: _ctx.headers,
                                items: _ctx.filteredCompanies,
                                page: _ctx.pagination.page,
                                "onUpdate:page": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pagination.page) = $event)),
                                "sort-by": _ctx.pagination.sortBy,
                                "onUpdate:sortBy": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pagination.sortBy) = $event)),
                                "items-per-page": _ctx.pagination.rowsPerPage,
                                "onUpdate:itemsPerPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                "items-length": _ctx.totalCompaniesCount,
                                "fixed-header": "",
                                "items-per-page-options": [10, 20, 30],
                                "calculate-widths": "",
                                loading: _ctx.loading,
                                height: 
                                        _ctx.mode === 'InternalManagement'
                                            ? 'calc(100vh - 245px)'
                                            : 'calc(100vh - 300px)'
                                    ,
                                class: "table"
                              }, {
                                item: _withCtx((props) => [
                                  _createVNode(_component_AccountingClientMonitoringProductionRow, {
                                    props: props,
                                    headers: _ctx.headers,
                                    itemValue: _ctx.getValueForItem(props.item.id),
                                    taxesMonitoringItem: 
                                                _ctx.getTaxesMonitoringItem(props.item.id)
                                            ,
                                    optionsSelected: _ctx.optionsSelected,
                                    showFECInfo: _ctx.showFECInfo
                                  }, null, 8, ["props", "headers", "itemValue", "taxesMonitoringItem", "optionsSelected", "showFECInfo"])
                                ]),
                                _: 1
                              }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length", "loading", "height"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, {
                    class: "mt-1",
                    value: "taxes"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_data_table_server, {
                                headers: _ctx.headers,
                                items: _ctx.filteredCompanies,
                                page: _ctx.pagination.page,
                                "onUpdate:page": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pagination.page) = $event)),
                                "sort-by": _ctx.pagination.sortBy,
                                "onUpdate:sortBy": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pagination.sortBy) = $event)),
                                "items-per-page": _ctx.pagination.rowsPerPage,
                                "onUpdate:itemsPerPage": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                "items-length": _ctx.totalCompaniesCount,
                                "fixed-header": "",
                                "items-per-page-options": [10, 20, 30],
                                "calculate-widths": "",
                                loading: _ctx.loading,
                                height: 
                                        _ctx.mode === 'InternalManagement'
                                            ? 'calc(100vh - 245px)'
                                            : 'calc(100vh - 300px)'
                                    ,
                                class: "table"
                              }, {
                                item: _withCtx((props) => [
                                  _createVNode(_component_AccountingClientMonitoringTaxesRow, {
                                    props: props,
                                    headers: _ctx.headers,
                                    itemValue: _ctx.getValueForItem(props.item.id),
                                    taxesMonitoringItem: 
                                                _ctx.getTaxesMonitoringItem(props.item.id)
                                            ,
                                    taxesSelected: _ctx.taxesSelected,
                                    taxType: _ctx.selectedView,
                                    hideName: false
                                  }, null, 8, ["props", "headers", "itemValue", "taxesMonitoringItem", "taxesSelected", "taxType"])
                                ]),
                                _: 1
                              }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length", "loading", "height"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, {
                    class: "mt-1",
                    value: "finalization"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_data_table_server, {
                                headers: _ctx.headers,
                                items: _ctx.filteredCompanies,
                                page: _ctx.pagination.page,
                                "onUpdate:page": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.pagination.page) = $event)),
                                "sort-by": _ctx.pagination.sortBy,
                                "onUpdate:sortBy": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pagination.sortBy) = $event)),
                                "items-per-page": _ctx.pagination.rowsPerPage,
                                "onUpdate:itemsPerPage": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                                "items-length": _ctx.totalCompaniesCount,
                                "fixed-header": "",
                                "items-per-page-options": [10, 20, 30],
                                "calculate-widths": "",
                                loading: _ctx.loading,
                                height: 
                                        _ctx.mode === 'InternalManagement'
                                            ? 'calc(100vh - 245px)'
                                            : 'calc(100vh - 300px)'
                                    ,
                                class: "table"
                              }, {
                                item: _withCtx((props) => [
                                  _createVNode(_component_AccountingClientMonitoringClosureRow, {
                                    props: props,
                                    headers: _ctx.headers,
                                    auditReportMonitoring: _ctx.auditReportMonitoring,
                                    loading: _ctx.loading,
                                    hideName: false
                                  }, null, 8, ["props", "headers", "auditReportMonitoring", "loading"])
                                ]),
                                _: 1
                              }, 8, ["headers", "items", "page", "sort-by", "items-per-page", "items-length", "loading", "height"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.userDialog,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.userDialog) = $event)),
        title: 'Collaborateur',
        "max-width": "800px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_select_user, {
            class: "px-1",
            modelValue: _ctx.selectedUser,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedUser) = $event)),
            companyId: _ctx.$store.state.user.company.id,
            type: 'NATURAL_PERSON',
            withEmail: true,
            onUserSelected: _cache[21] || (_cache[21] = ($event: any) => (_ctx.userDialog = false))
          }, null, 8, ["modelValue", "companyId"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}